export const SET_SUBSTATIONS = "SET_SUBSTATIONS";
export const SET_FEEDERS = "SET_FEEDERS";
export const SET_POLE_TYPES = "SET_POLE_TYPES";
export const SET_CUSTOMERS = "SET_CUSTOMERS";
export const SET_PART_CATEGORIES = "SET_PART_CATEGORIES";
export const SET_PARTS= "SET_PARTS";
export const SET_CREWS= "SET_CREWS";
